<div *transloco="let t;" class="row onboarding flex gap-4" style="background-image: url('./assets/img/BG/BG-Onboarding.jpg');">
  <div class="col-lg-6 col w-full md:w-1/2">
    <div class="chat-container">
      <div class="chat-box">
        <img src="./assets/img/portal-op.png" />
        <div class="chat-box-text">
          <h1 class="title-gradient gradient-pp">{{t('onboarding.heyBro')}}</h1>
          <p>{{t('onboarding.drGuzmanPresentation')}}</p>
          <!--<div class="button-gradient" (click)="stepsRouter()">Let's start</div>-->
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-6 col w-full md:w-1/2">
    <div class="card pick-card">
      <div class="intro-text">
        <h1>{{t('onboarding.realOrSynthetic')}}</h1>
      </div>
    </div>
    <div class="card">
      <div class="button-actions">
        <div class="start-box-select" (click)="gotoFind()">
          <img src="./assets/img/Icon/Icon-KMON.svg" />
          <h1>{{t('shared.realKryptomon')}}</h1>
          <p>{{t('onboarding.realDescription')}}</p>
        </div>
        <div class="start-box-select" (click)="gotoFreetoplay()">
          <div class="cr cr-top cr-right cr-purple">Free</div>
          <img src="./assets/img/Icon/Starter.png" />
          <h1>{{t('shared.syntheticKryptomon')}}</h1>
          <p>{{t('onboarding.syntheticDescription')}}</p>
        </div>
      </div>
    </div>
  </div>